import { FC, lazy, Suspense, useCallback, useEffect } from 'react'
import { Route, Routes } from 'react-router-dom'

import Loading from '@parts/parts/Loadings/Loading/Loading'
const EditorPage = lazy(() => import('pages/editorPage/EditorPage'))
const LoginPage = lazy(() => import('pages/loginPage/LoginPage'))
const Presentations = lazy(() => import('pages/presentations/Presentations'))
import { useAuthStore, useClientsStore } from 'shared/store'

const NotAllowedPage = lazy(() => import('pages/notAllowedPage/notAllowedPage'))
import NotFoundPage from 'pages/notFoundPage/notFoundPage'
import { getAllClientsNames } from '@utils/axios/axiosQueries/presentation.requests'
import { AuthStatus } from 'shared/types'
import { PresClient } from './types/presentation.type'

import styles from './assets/styles/App.module.scss'

const App: FC = () => {
  const { authStatus } = useAuthStore((state) => state)
  const { setClients } = useClientsStore((state) => state)

  const getClientsNames = useCallback(async () => {
    const clientsResult: PresClient[] = await getAllClientsNames()
    if (clientsResult) {
      const newClients: Record<string, string> = {}
      clientsResult.forEach((c) => {
        newClients[c.name] = c._id
      })
      setClients(newClients)
    }
  }, [setClients])

  useEffect(() => {
    getClientsNames()
  }, [])

  return (
    <div className={styles.app}>
      {authStatus === AuthStatus.PENDING && <Loading wrapperModificator={styles.app} />}
      {authStatus !== AuthStatus.PENDING && (
        <Suspense>
          <Routes>
            {authStatus === AuthStatus.AUTHORIZED && (
              <>
                <Route path={'/'} element={<Presentations />} />
                <Route path={'presentation/:id'} element={<EditorPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </>
            )}
            {authStatus === AuthStatus.NO_AUTH && <Route path="*" element={<LoginPage />} />}
            <Route path="/not-allowed" element={<NotAllowedPage />} />
          </Routes>
        </Suspense>
      )}
    </div>
  )
}

export default App
